import { Component, inject } from '@angular/core';
import { LevelPerActivityService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LevelPerActivityCreateDto,
  LevelPerActivityDto,
  LevelPerActivityExcelDownloadDto,
  LevelPerActivityUpdateDto,
} from '../proxy/controlling/dtos/level-per-activity';
import { LEVELPERACTIVITY_CONFIG, LEVELPERACTIVITY_FIELDS } from './level-per-activity.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-level-per-activity',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, LevelPerActivityService, ConfirmationService],
  templateUrl: './level-per-activity.html',
  styleUrl: './level-per-activity.scss',
})
export class LevelPerActivity extends BaseHierarchicalCrudComponent<
  LevelPerActivityDto,
  LevelPerActivityCreateDto,
  LevelPerActivityUpdateDto,
  LevelPerActivityExcelDownloadDto
> {
  service = inject(LevelPerActivityService);
  config = LEVELPERACTIVITY_CONFIG;
  fields = LEVELPERACTIVITY_FIELDS;

  protected prepareUpdateDto(data: any, selected: LevelPerActivityDto): LevelPerActivityUpdateDto {
    return {
      levelId: data.levelId,
      activityId: data.activityId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'LevelPerActivity';
  }
}
